import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} Fabian Trejo · Built with React</p>
    </footer>
  );
}

export default Footer;
